export default "__VITE_ASSET__AaepzC1P__"